const AUTH_NEXT_KEY = 'authNextPath';

/**
 * Only allow same-origin relative paths (block open redirects).
 * Query values may contain absolute URLs (e.g. Memories bridge return=).
 */
export function sanitizeNextPath(value) {
  if (!value || typeof value !== 'string') return null;
  const next = value.trim();
  if (!next.startsWith('/')) return null;
  if (next.startsWith('//')) return null;
  if (next.includes('\\')) return null;
  const pathOnly = next.split('?')[0].split('#')[0];
  if (!pathOnly.startsWith('/') || pathOnly.startsWith('//') || pathOnly.includes('://')) {
    return null;
  }
  // Bridge return URLs are longer once encoded.
  return next.slice(0, 2000);
}

export function rememberAuthNext(value) {
  const next = sanitizeNextPath(value);
  if (typeof window === 'undefined') return next;
  if (next) {
    try {
      sessionStorage.setItem(AUTH_NEXT_KEY, next);
    } catch {
      // ignore quota / private mode
    }
  }
  return next;
}

export function consumeAuthNext(fallback = null) {
  if (typeof window === 'undefined') return sanitizeNextPath(fallback);
  let stored = null;
  try {
    stored = sessionStorage.getItem(AUTH_NEXT_KEY);
    sessionStorage.removeItem(AUTH_NEXT_KEY);
  } catch {
    // ignore
  }
  return sanitizeNextPath(stored) || sanitizeNextPath(fallback);
}

export function peekAuthNext() {
  if (typeof window === 'undefined') return null;
  try {
    return sanitizeNextPath(sessionStorage.getItem(AUTH_NEXT_KEY));
  } catch {
    return null;
  }
}

export function appendNextParam(url, next) {
  const safe = sanitizeNextPath(next);
  if (!safe) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}next=${encodeURIComponent(safe)}`;
}
